<template>
  <div class="mb-15">
    <div class="d-flex">
      <page-title value="献立・検食" />
      <v-spacer />
      <v-menu offset-y>
        <template v-slot:activator="{ props }">
          <v-btn
            color="primary"
            variant="outlined"
            v-bind="props"
          >
            <v-icon start>mdi-tray-arrow-down</v-icon>
            ダウンロード
          </v-btn>
        </template>
        <v-list>
          <v-list-item href="https://stg-data.c-c-s.app/public/meal/%E7%8C%AE%E7%AB%8B%E8%A1%A8%E3%82%A4%E3%83%B3%E3%83%9B%E3%82%9A%E3%83%BC%E3%83%88%E7%94%A8_Excel%E3%83%86%E3%83%B3%E3%83%95%E3%82%9A%E3%83%AC%E3%83%BC%E3%83%88.xlsx">
            <v-list-item-title>サンプルCSV</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <div class="my-8">
      <v-card
        class="pa-4"
        color="#f0f0f0"
        variant="flat"
      >
        <div class="d-flex mb-4 align-center">
          <h3 class="mr-2">本日の献立 - {{ todayLabel }} </h3>
          <v-btn
            variant="flat"
            color="primary"
            @click="setCreating(todayCode)"
          >追加</v-btn>
        </div>
        <div v-if="todaysMenu && todaysMenu.menus.length > 0">
          <div class="pa-2" style="background-color: white;">
            <div class="menu-table-row-col-items">
              <div 
                class="menu-table-row-col-item"
                v-for="(menu, i) in todaysMenu.menus"
                :key="i"
              >
                <div class="menu-table-row-col col-category">
                  {{ menu.category.name }}
                </div>
                <div class="menu-table-row-col col-menu">
                  {{ menu.body }}
                </div>
                <div class="menu-table-row-col col-classes">
                  {{ formatClassNames(menu.category.targetClasses) }}
                </div>
                <div class="menu-table-row-col col-actions">
                  <v-btn
                    color="primary"
                    variant="flat"
                    rounded
                    class="mx-1"
                    small
                    @click="openTestDialog(menu)"
                  >
                    <span v-if="menu.test">検食済み</span>
                    <span v-else>検食</span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    variant="outlined"
                    rounded
                    class="mx-1"
                    small
                    @click="openEditDialog(menu)"
                  >
                    編集
                  </v-btn>
                  <v-btn
                    color="red"
                    variant="outlined"
                    rounded
                    class="mx-1"
                    small
                    @click="deleteMenu(menu)"
                  >
                    削除
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>本日の献立は登録されていません。</div>
      </v-card>
    </div>

    <div class="my-4">
      <month-pager v-model="yearMonth"
        @input="pageClick"
      />
    </div>
    <div class="my-4">
      <v-btn
        variant="flat"
        color="primary"
        @click="openImportDialog"
      >献立表をインポート</v-btn>
    </div>

    <div v-if="importStatuses.length > 0" class="my-4">
      <v-card
        class="pa-4"
        color="#f0f0f0"
        variant="outlined"
      >
        <div>献立表のインポート状況</div>
        <v-card
          color="#fff"
          class="my-2 pa-2"
          variant="flat"
          v-for="(status, i) in importStatuses"
          :key="i"
        >
          <div class="d-flex align-center">
            <div>
              {{ status.filename }}
            </div>
            <v-spacer />
            <div>
              <v-chip v-if="status.status === 'inProgress'" small color="orange" variant="outlined">
                読み込み中
              </v-chip>
              <v-chip v-else-if="status.status === 'failed'" small color="red" variant="outlined">
                読み込みエラー
              </v-chip>
              <v-chip v-else-if="status.status === 'success'" small color="primary" variant="outlined">
                読み込み完了
              </v-chip>
            </div>
          </div>
        </v-card>
      </v-card>
    </div>

    <v-progress-linear v-if="isFetching" indeterminate class="my-4" color="primary" />

    <div class="menu-table">
      <div class="menu-table-headers">
        <div class="menu-table-header col-date">日付</div>
        <div class="menu-table-header col-category">種別</div>
        <div class="menu-table-header col-menu">献立</div>
        <div class="menu-table-header col-classes">対象クラス</div>
        <div class="menu-table-header col-actions"></div>
      </div>

      <div 
        class="menu-table-row"
        v-for="dwm in datesWithMenus"
        :key="dwm.date"
      >
        <div class="menu-table-row-col col-date">
          <div class="d-flex align-center">
            <div class="date-label"> {{ dwm.formatted }} </div>
            <v-spacer />
            <v-btn
              color="primary"
              variant="text"
              size="small"
              @click="setCreating(dwm.date)"
            >
              + 追加
            </v-btn>
          </div>
        </div>
        <div class="menu-table-row-col-items">
          <div 
            class="menu-table-row-col-item"
            v-for="(menu, i) in dwm.menus"
            :key="i"
          >
            <div class="menu-table-row-col col-category">
              {{ menu.category.name }}
            </div>
            <div class="menu-table-row-col col-menu">
              {{ menu.body }}
            </div>
            <div class="menu-table-row-col col-classes">
              {{ formatClassNames(menu.category.targetClasses) }}
            </div>
            <div class="menu-table-row-col col-actions">
              <v-btn
                color="primary"
                variant="flat"
                rounded
                class="mx-1"
                small
                @click="openTestDialog(menu)"
              >
                <span v-if="menu.test">検食済み</span>
                <span v-else>検食</span>
              </v-btn>
              <v-btn
                color="primary"
                variant="outlined"
                rounded
                class="mx-1"
                small
                @click="openEditDialog(menu)"
              >
                編集
              </v-btn>
              <v-btn
                color="red"
                variant="outlined"
                rounded
                class="mx-1"
                small
                @click="deleteMenu(menu)"
              >
                削除
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>

    <food-menu-create-container />
    <food-menu-test-container @delete:test="listMenus"/>
    <food-menu-edit-container />
    <food-menu-import-container />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

import dayjs from 'dayjs';
import { foodMenusModule } from '@/store/viewModules/food-menu/foodMenusModule';
import { MealPlanResponse, NurseryClassResponse } from 'chaild-api/lib';

import PageTitle from '@/components/atoms/PageTitle.vue';
import MonthPager from '@/components/atoms/MonthPager.vue';
import FoodMenuImportContainer from '@/containers/food-menu/FoodMenuImportContainer.vue';
import FoodMenuCreateContainer from '@/containers/food-menu/FoodMenuCreateContainer.vue';
import FoodMenuTestContainer from '@/containers/food-menu/FoodMenuTestContainer.vue';
import FoodMenuEditContainer from '@/containers/food-menu/FoodMenuEditContainer.vue';
import { foodMenuTestModule } from '@/store/viewModules/food-menu/foodMenuTestModule';

interface DateWithMenus {
  date: string;
  formatted: string;
  menus: MealPlanResponse[];
}

interface DataType {
  yearMonth: string;

  isFetching: boolean;
}

export default defineComponent({
  components: {
    PageTitle,
    MonthPager,
    FoodMenuCreateContainer,
    FoodMenuTestContainer,
    FoodMenuEditContainer,
    FoodMenuImportContainer,
  },

  data: (): DataType => ({
    yearMonth: dayjs().format('YYYY-MM'),
    
    isFetching: false,
  }),

  computed: {
    dates() {
      const date = dayjs(this.yearMonth).startOf('months');
      const daysInMonth = date.daysInMonth();
      return [...Array(daysInMonth)].map((emp, index) => {
        return date.add(index, 'day');
      });
    },
    testItems() {
      return [
        {
          category: '給食（離乳食）',
          menu: 'ご飯, 味噌汁, ひじき, オレンジ',
          classes: 'ひつじ組, きりん組, うさぎ組, ぞう組',
        }
      ]
    },
    importStatuses() {
      return foodMenusModule.importStatuses;
    },
    menus() {
      return foodMenusModule.menus;
    },
    datesWithMenus(): DateWithMenus[] {
      return this.dates.map((date) => {
        const thisdayMenus = this.menus.filter((menu) => menu.date === date.format('YYYY-MM-DD'));
        return {
          date: date.format('YYYY-MM-DD'),
          formatted: date.format('MM/DD (ddd)'),
          menus: thisdayMenus,
        };
      });
    },
    menuCategories() {
      return foodMenusModule.menuCategories;
    },
    allergens() {
      return foodMenusModule.allergens;
    },
    todayLabel() {
      return dayjs().format('MM/DD (ddd)')
    },
    todayCode() {
      return dayjs().format('YYYY-MM-DD')
    },
    todaysMenu(): DateWithMenus | null {
      const menu = this.datesWithMenus.find((dwm) => dwm.date === dayjs().format('YYYY-MM-DD'));
      return menu || null;
    }
  },

  methods: {
    async pageClick(pageNumber) {
      if (pageNumber) sessionStorage.setItem('foodMenusYearMonth', String(pageNumber));
    },
    async listMenus() {
      this.isFetching = true;
      await foodMenusModule.listMenus({
        yearMonth: this.yearMonth
      });
      this.isFetching = false;
    },
    async listImportStatus() {
      const day = dayjs(this.yearMonth);
      let year = day.year();
      const month = day.month() + 1;

      if (month < 4) {
        year = year - 1;
      }

      foodMenusModule.listImportStatus({
        year,
        month,
      })
    },
    listMenuCategories() {
      foodMenusModule.listMealCategories();
    },
    listAllergens() {
      foodMenusModule.listAllergens();
    },
    setCreating(date: string) {
      foodMenusModule.setCreatingDate(dayjs(date).format('YYYY-MM-DD'));
    },
    formatClassNames(classes: NurseryClassResponse[]) {
      return classes.map((c) => c.className).join(',');
    },
    openTestDialog(menu: MealPlanResponse) {
      foodMenuTestModule.setTestingMeal(menu);
    },
    openEditDialog(menu: MealPlanResponse) {
      foodMenusModule.setEditingMenu(menu);
    },
    openImportDialog() {
      foodMenusModule.setImportYearMonth(this.yearMonth);
      foodMenusModule.setIsImportDataDialogOpen(true);
    },
    async deleteMenu(menu: MealPlanResponse) {
      if (window.confirm('献立を削除しますか？')) {
        this.isFetching = true;
        await foodMenusModule.deleteMenu(menu.planId);
        await foodMenusModule.listMenus({ yearMonth: this.yearMonth });
        this.isFetching = false;
      }
    }
  },

  watch: {
    yearMonth: {
      handler: function() {
        this.listMenus();
        this.listImportStatus();
      },
    }
  },

  mounted() {
    const foodMenusYearMonth = sessionStorage.getItem('foodMenusYearMonth');
    if (foodMenusYearMonth) this.yearMonth = foodMenusYearMonth;
    this.listMenus();
    this.listImportStatus();
    this.listMenuCategories();
    this.listAllergens();
  }
});
</script>
<style lang="scss" scoped>
.menu-table-headers {
  display: flex;
  height: 30px;

  border-bottom: solid 1px #e0e0e0;
}

.menu-table-row {
  display: flex;

  border-bottom: solid 1px #e0e0e0;
}

.menu-table-header {
  font-size: 12px;
  font-weight: bold;
  line-height: 30px;
  
  padding: 0 8px;
}

.col-date {
  width: 160px;
}

.col-category {
  width: 160px;
}

.col-menu, .col-classes {
  flex: 1;
}

.col-actions {
  width: 300px;
}

.menu-table-row-col {
  padding: 8px;
  padding-top: 12px;

  font-size: 14px;

  &.col-date {
    border-right: solid 1px #e0e0e0;
  }
}

.menu-table-row-col-items {
  flex: 1;
}

.menu-table-row-col-item {
  display: flex;

  &:hover {
    background-color: #f0f0f0;
  }
}

.date-label {
  font-size: 14px;
}
</style>